<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showcoupons") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #7514b7">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- End:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.code')"
            v-model="data.code"
            required
            disabled
          />
          <!-- End:: Status Input -->

          <!-- Start:: Discount Type Input -->

          <!-- End:: Discount Type Input -->

          <!-- Start:: Discount Value Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.discountPercentage')"
            v-model="data.discount"
            :min="1"
            :max="100"
            required
            disabled
          />
          <!-- End:: Discount Value Input -->

          <!-- End:: Status Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.startDate')"
            v-model.trim="data.from_date"
            disabled
          />
          <!-- End:: Start Date Input -->

          <!-- Start:: End Date Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.endDate')"
            v-model.trim="data.to_date"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.max_discount')"
            v-model="data.max_discount"
            required
            disabled
          />
          <!-- End:: Name Input -->



          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.users')"
            v-model="data.users"
            required
            :optionsList="allUsers"
            multiple
            disabled
          />

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "showCity",

  
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        code: null,
        discount_type: null,
        discount: null,
        from_date: null,
        to_date: null,
        users: null,
        max_discount: null,
        countryFact: null,
        quantaty: null,
        min_quantaty: null,
        mostPaid: null,
        productCode: null,
        choose_all: 0,
        active: null,
        nameAr: null,
        nameEn: null,
        active: true,
      

},
      regions: [],
      allUsers: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    discountTypes() {
      return [
        {
          id: 1,
          name:
            this.$t("PLACEHOLDERS.discountValue") +
            " - " +
            this.$t("PLACEHOLDERS.riyal"),
          value: "value",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.discountPercentage") + " (0-100%)",
          value: "percentage",
        },
      ];
    },
  },

  methods: {
    // start show data
    async showCity() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `coupons/${this.$route.params.id}`,
        });

        this.data.code = res.data.data.data.code;
        this.data.nameAr = res.data.data.data.name_ar;
        this.data.nameEn = res.data.data.data.name_en;
        this.data.from_date = res.data.data.data.start_date;
        this.data.to_date = res.data.data.data.end_date;
        this.data.users = res.data.data.data.users;
        this.data.discount = res.data.data.data.discount;
        this.data.max_discount = res.data.data.data.max_discount;

        this.data.active = res.data.data.data.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            is_active: 1,
          },
        });
        // console.log("Cities =>", res.data.data);
        this.regions = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.showCity();
    // End:: Fire Methods
  },
};
</script>
